export default "__VITE_ASSET__DSjkci09__"